import { Informe } from './../../../models/informe.model';
import { Component } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-informe",
    templateUrl: "./informe.component.html",
    styleUrls: ["./informe.component.css"],
    providers: [FormService]
})

export class InformeComponent {
    public rows = [];
    public actualRow;
    public informe: Informe;
    public form;
    public maxDate
    public  fech_informe;

    matcher = new FormService();


  constructor(public _formService: FormService, private fb:FormBuilder){

    this.maxDate = moment().toDate()

    this.form = new FormGroup({
        infradio: new FormControl(''),
        num_informe: new FormControl('', [Validators.min(0),Validators.pattern(/[0-9]*/)]),
        fech_informe: new FormControl({value :'', disabled : true})
        
    })

    if(!JSON.parse(localStorage.getItem("informe"))){
          localStorage.setItem("informe", JSON.stringify(this.rows));
    }else{
        this.rows = JSON.parse(localStorage.getItem("informe"));

        this.form.controls['infradio'].setValue(this.rows[0]?this.rows[0].infradio:false);
        this.form.controls['num_informe'].setValue(this.rows[0]?this.rows[0].num_informe:'')
        this.form.controls['fech_informe'].setValue(this.rows[0]? moment(this.rows[0].fech_informe, "DD/MM/YYYY").toDate():null)
        
      }
      

  }

  add_informe(event?: MatDatepickerInputEvent<Date>, type?){

    if(event){
        this.fech_informe = moment(event.value).format('DD/MM/YYYY')
   } else {
       var temp = JSON.parse(localStorage.getItem("informe"))
       if(temp > 0){
           this.fech_informe = temp[0].fech_informe
       }else {
           this.fech_informe = ''
       }
       
   }
    localStorage.setItem("informe",JSON.stringify([]));
      this.actualRow = localStorage.getItem("informe");
      this.rows = JSON.parse(this.actualRow);
      this.rows = this.rows.concat({
        infradio: this.form.value.infradio,
        num_informe : this.form.value.num_informe,
        fech_informe:this.fech_informe
      })
      localStorage.setItem("informe", JSON.stringify(this.rows));
  }

  delete_informe(id){
      for(let x = 0; x < this.rows.length; x++){
          if(id == x){
              this.rows.splice(x, 1);
              localStorage.setItem("informe", JSON.stringify(this.rows));
          }
      }
  }  
}